import { render, staticRenderFns } from "./EmrPDFViewer.vue?vue&type=template&id=7c0d4863&scoped=true"
import script from "./EmrPDFViewer.vue?vue&type=script&lang=js"
export * from "./EmrPDFViewer.vue?vue&type=script&lang=js"
import style0 from "./EmrPDFViewer.vue?vue&type=style&index=0&id=7c0d4863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d4863",
  null
  
)

export default component.exports